import axios from "axios";

const getRecipientNamesByTour = async (token, tourId) => {
  const path = `${process.env.REACT_APP_BACKEND_API_URL}/tours/${tourId}/recipients`;

  try {
    const response = await axios.get(path, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    return response;
  } catch (error) {
    console.log(error.response);
    return error.response;
  }
};

export default getRecipientNamesByTour;